import React, { useContext } from 'react';
import MessagingRouter from '../../Messaging.router';
import MessagingProvider from '../../providers/Messaging';
import ListingContext from '../../../Portfolio/subrouters/Seller/subrouters/ListingDetailSeller/providers/Listing/Listing.context';
import { useLockScrollOnReroute } from 'hooks/useLockScrollOnReroute';

const MessagingSellerWrapper: React.FC = () => {
  const { listing } = useContext(ListingContext);

  useLockScrollOnReroute();

  return (
    <MessagingProvider
      listingId={listing?._id}
      dealRoomId={listing?.dealRoomId}
      listingEnquiryId={listing?.listingEnquiryId}
    >
      <MessagingRouter />
    </MessagingProvider>
  );
};

export default MessagingSellerWrapper;
